import Main from './main'

export default new class Constants {
  getVersion () {
    return '1.0.11'
  }

  isDev () {
    return Main.app.$store.state.user.data.isDev
  }
}()
